import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import EmailAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/EmailAppIcon';

import Spacer20 from '../../../Misc/Spacer20.js';

const EmailStrategy = {
  previewInfo: {
    name: 'Email automation',
    href: '/pro/marketing/email',
    iconSvg: <EmailAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Email automation',
    category: 'Automate sending emails before + after jobs',
    details: (
      <div>
        Send before & after emails to your customers.
        <Spacer20 />
        <span style={{ fontWeight: 500 }}>Before the job</span> - Send an automated email reminder of the appointment to
        reduce no shows. Send a job prep email so everything is ready to go when you get to the job site.
        <Spacer20 />
        <span style={{ fontWeight: 500 }}>After the job</span> - Send an automated email after the job to say thanks and
        ask for a review. Follow-up in a few months to get a re-booking.
      </div>
    ),
    iconSvg: <EmailAppIcon size="xlarge" />,
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/5p5gevxcun?autoPlay=false',
  },
  sellingPoints: {},
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: true,
    hideCard: true,
    appActionButton: (
      <Button
        variant="contained"
        color="primary"
        style={{ color: '#ffffff', width: '100%' }}
        href="/pro/marketing/email"
      >
        Go to email marketing
      </Button>
    ),
  },
  supportContacts: [],
};

export default EmailStrategy;
